import { useInitContext } from '@providers/InitProvider';
import { routes } from '@routes';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import CrossIcon from '@components/icons/LandingCross.svg';
import Hamburger from '@components/icons/LandingHamburger.svg';
import Logo from '@components/icons/LandingLogo.svg';
import WhiteLogo from '@components/icons/LandingWhiteLogo.svg';
import { IconButtonRegular as IconButton } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonRegular';
import { Wrapper } from './styles/Wrapper';

export const LandingPageMobileHeader = () => {
  const navigate = useNavigate();
  const [menuVisible, setMenuVisible] = useState(false);

  const openDashboard: React.MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.preventDefault();
    window.scroll(0, 0);
    navigate('/dashboard');
  };
  const goToRegister: React.MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.preventDefault();
    window.scroll(0, 0);
    navigate(routes.signup.make());
  };
  const goToContactSales: React.MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.preventDefault();
    window.scroll(0, 0);
    navigate(routes.contactSales.make());
  };

  const { isAuthenticated } = useInitContext();

  return (
    <Wrapper className="mobile">
      <div className="left-side">
        <div className="logo">
          <RouterLink
            to="/"
            onClick={() => {
              window.scroll(0, 0);
            }}
          >
            <Logo />
          </RouterLink>
        </div>
      </div>
      <div className="right-side">
        <IconButton
          onClick={(e) => {
            e.preventDefault();
            setMenuVisible(true);
          }}
        >
          <Hamburger />
        </IconButton>
      </div>

      {menuVisible ? (
        <div className="opened">
          <div className="flex">
            <div className="left-side">
              <div className="logo">
                <RouterLink
                  to="/"
                  onClick={() => {
                    window.scroll(0, 0);
                  }}
                >
                  <WhiteLogo />
                </RouterLink>
              </div>
            </div>
            <div className="right-side">
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  setMenuVisible(false);
                }}
              >
                <CrossIcon />
              </IconButton>
            </div>
          </div>

          <div className="menu">
            <button className="white-button" onClick={goToContactSales}>
              Contact Sales
            </button>
            {!isAuthenticated ? (
              <button className="primary-button" onClick={goToRegister}>
                Get Started
              </button>
            ) : (
              <button className="primary-button" onClick={openDashboard}>
                Dashboard
              </button>
            )}
          </div>
        </div>
      ) : null}
    </Wrapper>
  );
};
